/**
 *
 * Asynchronously loads the component for AdvisorLayout
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorLayout = lazyLoad(
  () => import('./index'),
  module => module.AdvisorLayout,
);
